// 神策埋点
// import sensors from 'sa-sdk-javascript';
import { ENV } from '@/config/env';
import { getQueryString } from '@hll/eapp-utils';

// van全局注入，如果没有默认dev
const urlEnv = ENV === 'prod' ? '' : '-pre';
const url = `https://uba${urlEnv}.huolala.cn/sa?project=enterprise`;
const statLog: string | null = getQueryString('salog');
interface Stat {
  login: (userId: string | number) => void;
  track: (name: string, p: any) => void;
}

let showLog: boolean = false;
if (statLog === 'true') {
  showLog = true;
}
if (ENV === 'prod') {
  showLog = false;
}

export default async function () {
  try {
    const sensors: any = await import('sa-sdk-javascript');

    sensors.init({
      server_url: url,
      heatmap: {
        clickmap: 'not_collect',
        scroll_notice_map: 'not_collect',
      },
      // 是否在控制台打日志
      show_log: showLog,
    });

    sensors.registerPage({
      platform_type: 'eppc', // 企业PC标识
      // 埋点版本追踪
      vanTaskId: document?.documentElement?.dataset?.vanTaskId || '未获取成功',
    });

    sensors.quick('autoTrack');

    return sensors as Stat;
  } catch (error) {
    console.error('Failed to import sa-sdk-javascript:', error);
    throw error;
  }
}

// export default sensors as Stat;
